import { render, staticRenderFns } from "./trusteeship.vue?vue&type=template&id=52de1041&scoped=true&"
import script from "./trusteeship.vue?vue&type=script&lang=js&"
export * from "./trusteeship.vue?vue&type=script&lang=js&"
import style0 from "./trusteeship.vue?vue&type=style&index=0&id=52de1041&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52de1041",
  null
  
)

export default component.exports